import { Component, OnDestroy, OnInit } from '@angular/core';
import { ModalService, ModalType } from 'src/app/services/modal.service';
import { FormsService } from '../../services/forms.service';
import { getCountryZone, isToday, toDateString } from '../../utils';
import isAppAgentOrTravelAgency from '../../utils/is-agent-or-travel-agency.util';
import { MAX_INSURANCE_DIFF, MIN_INSURANCE_DIFF_PL } from '../settings';
import { Store } from '@ngrx/store';
import { BehaviorSubject, Subject, combineLatest, map, takeUntil } from 'rxjs';
import { AppState } from '../../store';
import * as fromConfig from '../../store/config/config.reducer';

@Component({
  selector: 'app-form-resignation',
  templateUrl: './resignation.component.html',
  styleUrls: ['./resignation.component.scss'],
})
export class ResignationComponent implements OnInit, OnDestroy {
  formGroup = this.formsService.resignation;
  modalType = ModalType;
  isAppAgentOrTravelAgency = isAppAgentOrTravelAgency();
  today = new Date().toString();
  countries$ = this.store.select(fromConfig.selectConfigTripAbroadCountries);
  countriesOptions$ = this.countries$.pipe(
    map((countries) => [
      {
        label: 'information-about-journey.highlighted',
        options:
          countries
            ?.filter(({ isHightlighted }) => isHightlighted)
            .map(({ countryName, countryId }) => ({ label: countryName, value: `H${countryId}` })) || [],
      },
      {
        label: 'information-about-journey.others',
        options: countries?.map(({ countryName, countryId }) => ({ label: countryName, value: String(countryId) })) || [],
      },
    ]),
  );
  countryAdditionalInfo$ = new BehaviorSubject<string | null>(null);
  ngDestroy$ = new Subject<void>();

  constructor(private store: Store<AppState>, private formsService: FormsService, public modalService: ModalService) {}

  get minDate(): string | undefined {
    const date = new Date();
    date.setDate(date.getDate() + MIN_INSURANCE_DIFF_PL);

    return toDateString(date);
  }

  ngOnInit() {
    this.implementUpdateCountryAdditionalInfo();
  }

  ngOnDestroy(): void {
    this.ngDestroy$.next();
    this.ngDestroy$.complete();
  }

  handleAddNewTravelCost(): void {
    this.formsService.addNewTravelCost();
  }

  handleRemoveTravelCost(index: number): void {
    this.formsService.removeTravelCost(index);
  }

  maxDate(dateAsString: string | null): string | undefined {
    if (!dateAsString) {
      return undefined;
    }

    const date = new Date(dateAsString);
    date.setDate(date.getDate() + MAX_INSURANCE_DIFF);

    return toDateString(date);
  }

  maxTravelPurchaseDate(): string | undefined {
    const today = new Date();

    return toDateString(today);
  }

  isTodaySelected(date: string | Date | null): boolean | null {
    return date ? isToday(date) : null;
  }

  private implementUpdateCountryAdditionalInfo(): void {
    combineLatest([this.countries$, this.formGroup.controls.destination.valueChanges])
      .pipe(takeUntil(this.ngDestroy$))
      .subscribe(([countries, destination]) => {
        const zone = getCountryZone(destination, countries);

        if (!zone) {
          this.countryAdditionalInfo$.next(null);

          return;
        }

        return this.countryAdditionalInfo$.next(`information-about-journey.destination.additionalInfo.${zone.toLowerCase()}`);
      });
  }
}
